import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "billing--container ma--top-1" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row ma--bottom-1"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart btn--icon__prefix" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Add Subscription", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "card-content" }
const _hoisted_13 = { class: "table table--striped" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, [
      /*#__PURE__*/_createTextVNode(" Date "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "The date credits were purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, [
      /*#__PURE__*/_createTextVNode(" Fields "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info",
        "data-tooltip": "The number of credits purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-right" }, [
      /*#__PURE__*/_createTextVNode(" Amount "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "The dollar amount spent on credits."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ])
  ])
], -1)
const _hoisted_15 = { class: "text--align-left" }
const _hoisted_16 = { class: "text--align-left" }
const _hoisted_17 = { class: "text--align-right" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PurchaseSubscription = _resolveComponent("PurchaseSubscription")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn--primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePurchaseModel = true))
                }, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$filters.dateDisplay(item.startDate)), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item.fields.map(f => f.text).join(", ")), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$filters.numberDisplay(item.amount, 2, 2, "$")), 1)
                      ]))
                    }), 128)),
                    (_ctx.response.length == 0 && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, _hoisted_20))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.togglePurchaseModel)
                  ? (_openBlock(), _createBlock(_component_PurchaseSubscription, {
                      key: 0,
                      subscriptions: _ctx.response,
                      onCancel: _ctx.onCancelPurchase
                    }, null, 8, ["subscriptions", "onCancel"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
  ]))
}